import {
  AccountService,
  AiService,
  CustomFieldService,
  OrgConfigService,
  CustomFieldDfnService,
  BenefitService,
  BenefitTypeService,
  BenefitUpdateService,
  CommitmentService,
  CommitmentUpdateService,
  ContributorService,
  CorporateRiskMitigationActionService,
  CorporateRiskMitigationActionUpdateService,
  CorporateRiskRiskMitigationActionService,
  CorporateRiskService,
  CorporateRiskUpdateService,
  DepartmentalObjectiveService,
  DependencyService,
  DependencyUpdateService,
  DirectorateService,
  DirectorateUpdateService,
  EntityStatusService,
  FinancialRiskMitigationActionService,
  FinancialRiskMitigationActionUpdateService,
  FinancialRiskService,
  FinancialRiskUpdateService,
  FinancialRiskUserGroupService,
  OrgLevel1Service,
  HealthCheckService,
  KeyWorkAreaService,
  KeyWorkAreaUpdateService,
  ListService,
  MeasurementUnitService,
  MetricService,
  MetricUpdateService,
  MilestoneService,
  MilestoneTypeService,
  MilestoneUpdateService,
  PartnerOrganisationRiskMitigationActionService,
  PartnerOrganisationRiskMitigationActionUpdateService,
  PartnerOrganisationRiskRiskTypeService,
  PartnerOrganisationRiskService,
  PartnerOrganisationRiskUpdateService,
  PartnerOrganisationService,
  PartnerOrganisationUpdateService,
  ProjectBusinessCaseTypeService,
  ProjectPhaseService,
  ProjectStageService,
  ProjectService,
  ProjectDepService,
  ProjectUpdateService,
  ReportBuilderService,
  ReportDueDatesService,
  ReportingEntityTypeService,
  ReportingFrequencyService,
  RiskAppetiteService,
  RiskDiscussionForumService,
  RiskImpactLevelService,
  RiskPermissionsService,
  RiskProbabilityService,
  RiskRiskTypeService,
  RiskTypeService,
  RoleService,
  SignOffService,
  ThresholdAppetiteService,
  ThresholdService,
  UserDirectorateService,
  UserGroupService,
  UserPartnerOrganisationService,
  UserProjectService,
  UserRoleService,
  UserService,
  WorkStreamService,
  WorkStreamUpdateService,
  OrgLevel3Service,
  PortfolioService,
  PPVisionService,
  PPObjectiveService,
  PPVisionObjectiveService,
  PortfolioUpdateService,
  ProgrammeService,
  ProgrammeStageService,
  ProgrammeUpdateService,
  ProgrammePhaseService,
  App03PortfolioUserService,
  App03PortfolioService,
  App03ProjectService,
  App03ProjectTypeService,
  App03EpicService,
  App03EpicObserverService,
  App03SprintService,
  App03WorkflowService,
  App03WorkflowStageService,
  App03WorkflowUserService,
  App03TaskService,
  App03SubTaskService,
  App03TaskUserService,
  GIAADefFormService,
  NAODefFormService,
  CLDefFormService,
  ZFileService,
  ZGraphDefnService,
  ZCoreDashboardService,
  GoDefFormService,
  GoDefElementService,
  GoDefElementOrgLevel1Service,
  IAPDefFormService,
  CADefFormService,
  CADefElementService,
  CAPeriodService,
  UserAppLaunchLogService,
  GIAAAuditReportService,
  NAOPublicationService,
  IAPActionService,
  CLCaseService,
  ZCoreAutomationOptionService,
  LogService,
  ZCoreEmailOutboxService,
  ZCoreEmailTemplateService,
  EmailNotificationsService,
  ZCoreUserGroupService,
  ZCoreUserGroupMemberService,
  CLComFrameworkService,
  CLDefApproverService,
  RiskAppHeatMapColorService,
  RiskAppIssueService,
  RiskAppIssueActionService,
  RiskAppIncidentActionService,
  RiskAppPriorityService,
  RiskAppStageService,
  RiskAppSourceService,
  RiskAppIncidentService,
  RiskAppIncidentTypeService,
  RiskAppReportingChannelService,
  RiskAppLocationService,
  RiskAppSeverityService,
  RiskAppSystemService,
  RiskAppStakeholderService,
  RiskAppImpactTypeService,
  RiskAppIncidentSystemService,
  RiskAppIncidentStakeholderService,
  RiskAppIncidentImpactTypeService,
  RiskAppIncidentIssueService,
  RiskAppEvidenceService,
  App03EpicDepService,
  App03TemplateService,
  App03WorkItemTypeService,
  RiskAppBandService,
  RiskAppScoreFormulaService,
  ZCoreAIChatService,
  ZCoreAIChatUserService
} from './services';

export const dataServices = {
  healthCheckService: new HealthCheckService(),
  customFieldService: new CustomFieldService(),
  accountService: new AccountService(),
  aiService: new AiService(),
  customFieldDfnService: new CustomFieldDfnService(),
  orgConfigService: new OrgConfigService(),
  benefitService: new BenefitService(),
  benefitTypeService: new BenefitTypeService(),
  benefitUpdateService: new BenefitUpdateService(),
  commitmentService: new CommitmentService(),
  commitmentUpdateService: new CommitmentUpdateService(),
  contributorService: new ContributorService(),
  corporateRiskMitigationActionService: new CorporateRiskMitigationActionService(),
  corporateRiskMitigationActionUpdateService: new CorporateRiskMitigationActionUpdateService(),
  corporateRiskRiskMitigationActionService: new CorporateRiskRiskMitigationActionService(),
  corporateRiskService: new CorporateRiskService(),
  corporateRiskUpdateService: new CorporateRiskUpdateService(),
  departmentalObjectivesService: new DepartmentalObjectiveService(),
  dependencyService: new DependencyService(),
  dependencyUpdateService: new DependencyUpdateService(),
  directorateService: new DirectorateService(),
  directorateUpdateService: new DirectorateUpdateService(),
  entityStatusService: new EntityStatusService(),
  financialRiskMitigationActionService: new FinancialRiskMitigationActionService(),
  financialRiskMitigationActionUpdateService: new FinancialRiskMitigationActionUpdateService(),
  financialRiskService: new FinancialRiskService(),
  financialRiskUpdateService: new FinancialRiskUpdateService(),
  financialRiskUserGroupService: new FinancialRiskUserGroupService(),
  orgLevel1Service: new OrgLevel1Service(),
  keyWorkAreaService: new KeyWorkAreaService(),
  keyWorkAreaUpdateService: new KeyWorkAreaUpdateService(),
  measurementUnitService: new MeasurementUnitService(),
  metricService: new MetricService(),
  metricUpdateService: new MetricUpdateService(),
  milestoneService: new MilestoneService(),
  milestoneTypeService: new MilestoneTypeService(),
  milestoneUpdateService: new MilestoneUpdateService(),
  partnerOrganisationRiskMitigationActionService: new PartnerOrganisationRiskMitigationActionService(),
  partnerOrganisationRiskMitigationActionUpdateService: new PartnerOrganisationRiskMitigationActionUpdateService(),
  partnerOrganisationRiskRiskTypeService: new PartnerOrganisationRiskRiskTypeService(),
  partnerOrganisationRiskService: new PartnerOrganisationRiskService(),
  partnerOrganisationRiskUpdateService: new PartnerOrganisationRiskUpdateService(),
  partnerOrganisationService: new PartnerOrganisationService(),
  partnerOrganisationUpdateService: new PartnerOrganisationUpdateService(),
  projectBusinessCaseTypeService: new ProjectBusinessCaseTypeService(),
  projectPhaseService: new ProjectPhaseService(),
  projectStageService: new ProjectStageService(),
  projectService: new ProjectService(),
  projectDepService: new ProjectDepService(),
  projectUpdateService: new ProjectUpdateService(),
  reportBuilderService: new ReportBuilderService(),
  reportDueDatesService: new ReportDueDatesService(),
  reportingEntityTypeService: new ReportingEntityTypeService(),
  reportingFrequencyService: new ReportingFrequencyService(),
  riskAppetiteService: new RiskAppetiteService(),
  riskDiscussionForumService: new RiskDiscussionForumService(),
  riskImpactLevelService: new RiskImpactLevelService(),
  riskPermissionsService: new RiskPermissionsService(),
  riskProbabilityService: new RiskProbabilityService(),
  riskRiskTypeService: new RiskRiskTypeService(),
  riskTypeService: new RiskTypeService(),
  roleService: new RoleService(),
  signOffService: new SignOffService(),
  thresholdService: new ThresholdService(),
  thresholdAppetiteService: new ThresholdAppetiteService(),
  userDirectorateService: new UserDirectorateService(),
  userGroupService: new UserGroupService(),
  userPartnerOrganisationService: new UserPartnerOrganisationService(),
  userProjectService: new UserProjectService(),
  userRoleService: new UserRoleService(),
  userService: new UserService(),
  workStreamService: new WorkStreamService(),
  workStreamUpdateService: new WorkStreamUpdateService(),
  orgLevel3Service: new OrgLevel3Service(),
  ppVisionService: new PPVisionService(),
  ppObjectiveService: new PPObjectiveService(),
  ppVisionObjectiveService: new PPVisionObjectiveService(),
  portfolioService: new PortfolioService(),
  portfolioUpdateService: new PortfolioUpdateService(),
  programmeService: new ProgrammeService(),
  programmeStageService: new ProgrammeStageService(),
  programmeUpdateService: new ProgrammeUpdateService(),
  programmePhaseService: new ProgrammePhaseService(),
  app03PortfolioUserService: new App03PortfolioUserService(),
  app03PortfolioService: new App03PortfolioService(),
  app03TemplateService: new App03TemplateService(),
  app03WorkItemTypeService: new App03WorkItemTypeService(),
  app03ProjectService: new App03ProjectService(),
  app03ProjectTypeService: new App03ProjectTypeService(),
  app03EpicService: new App03EpicService(),
  app03EpicDepService: new App03EpicDepService(),
  app03EpicObserverService: new App03EpicObserverService(),
  app03SprintService: new App03SprintService(),
  app03WorkflowService: new App03WorkflowService(),
  app03WorkflowUserService: new App03WorkflowUserService(),
  app03WorkflowStageService: new App03WorkflowStageService(),
  app03TaskService: new App03TaskService(),
  app03SubTaskService: new App03SubTaskService(),
  app03TaskUserService: new App03TaskUserService(),
  gIAADefFormService: new GIAADefFormService(),
  naoDefFormService: new NAODefFormService(),
  clDefFormService: new CLDefFormService(),
  goDefFormService: new GoDefFormService(),
  goDefElementService: new GoDefElementService(),
  goDefElementOrgLevel1Service: new GoDefElementOrgLevel1Service(),
  iapDefFormService: new IAPDefFormService(),
  caDefFormService: new CADefFormService(),
  caDefElementService: new CADefElementService(),
  caPeriodService: new CAPeriodService(),
  userAppLaunchLogService: new UserAppLaunchLogService(),
  zFileService: new ZFileService(),
  zGraphDefnService: new ZGraphDefnService(),
  zCoreDashboardService: new ZCoreDashboardService(),
  gIAAAuditReportService: new GIAAAuditReportService(),
  nAOPublicationService: new NAOPublicationService(),
  iAPActionService: new IAPActionService(),
  cLCaseService: new CLCaseService(),
  zCoreAutomationOptionService: new ZCoreAutomationOptionService(),
  logService: new LogService(),
  zCoreEmailOutboxService: new ZCoreEmailOutboxService(),
  zCoreEmailTemplateService: new ZCoreEmailTemplateService(),
  zCoreAIChatService: new ZCoreAIChatService(),
  zCoreAIChatUserService: new ZCoreAIChatUserService(),
  emailNotificationsService: new EmailNotificationsService(),
  zCoreUserGroupService: new ZCoreUserGroupService(),
  zCoreUserGroupMemberService: new ZCoreUserGroupMemberService(),
  cLComFrameworkService: new CLComFrameworkService(),
  cLDefApproverService: new CLDefApproverService(),
  riskAppHeatMapColorService: new RiskAppHeatMapColorService(),
  riskAppBandService: new RiskAppBandService(),
  riskAppScoreFormulaService: new RiskAppScoreFormulaService(),
  riskAppIssueService: new RiskAppIssueService(),
  riskAppIssueActionService: new RiskAppIssueActionService(),
  riskAppIncidentActionService: new RiskAppIncidentActionService(),
  riskAppPriorityService: new RiskAppPriorityService(),
  riskAppStageService: new RiskAppStageService(),
  riskAppSourceService: new RiskAppSourceService(),
  riskAppIncidentService: new RiskAppIncidentService(),
  riskAppIncidentTypeService: new RiskAppIncidentTypeService(),
  riskAppReportingChannelService: new RiskAppReportingChannelService(),
  riskAppLocationService: new RiskAppLocationService(),
  riskAppSeverityService: new RiskAppSeverityService(),
  riskAppSystemService: new RiskAppSystemService(),
  riskAppStakeholderService: new RiskAppStakeholderService(),
  riskAppImpactTypeService: new RiskAppImpactTypeService(),
  riskAppIncidentSystemService: new RiskAppIncidentSystemService(),
  riskAppIncidentStakeholderService: new RiskAppIncidentStakeholderService(),
  riskAppIncidentImpactTypeService: new RiskAppIncidentImpactTypeService(),
  riskAppIncidentIssueService: new RiskAppIncidentIssueService(),
  riskAppEvidenceService: new RiskAppEvidenceService(),
};
